/**
 * for ancient browsers that do not support the async clipboard api
 */
const fallbackCopy = (text: string) => {
    const tempInput = document.createElement('input');
    tempInput.value = text;
    tempInput.focus();
    tempInput.select();
    const copyResult = document.execCommand('copy');
    if (!copyResult) {
        throw Error('Failed to copy to clipboard using legacy API');
    }
};

export async function copyToClipboard(text: string) {
    if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(text);
    } else {
        fallbackCopy(text);
    }
}
